import React from 'react'
import lpllogo from '../assets/images/logo.png';
import suburbanlogo from '../assets/images/suburban.webp';
import npsbg from '../assets/images/NPSbg.png';
import '../assets/stylesheet/login.scss';


function OuterLayout() {
  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 col-xxl-8 position-relative">
      <div className="login-left">
        <div className="top-circle"></div>
      </div>
      <div className="overlay-login">
        <img src={lpllogo} className="App-logo" alt="logo" />
      </div>
      <div className="login-images">
        <img alt="NPS" src={npsbg} className="img-fluid" />
      </div>
    </div>
  );
}

export default OuterLayout
